import React from "react"
import styles from "../styles/scss/components/popularSearch.module.scss"

const PopularSearch = ({
    popularSearches,
    setResults,
    setTotal,
    setSubmited,
    setQuery,
    onSearch,
}) => {
    const handleClick = term => {
        if (onSearch) {
            onSearch(term).then(data => {
                setResults(data.results)
                setTotal(data.total)
                setSubmited(true)
                setQuery("query", term)
            })
        } else {
            // Default: redirect to search page with query
            window.location.href = `/search?q=${encodeURIComponent(term)}`
        }
    }

    return (
        <div className={styles.popularSearchMainWrapper}>
            <h2>Popular Searches</h2>
            <div className={styles.termList}>
                {popularSearches &&
                    popularSearches.length > 0 &&
                    popularSearches.split(",").map(term => (
                        <button
                            key={term}
                            type="button"
                            className="popular-search__item"
                            onClick={() => handleClick(term)}
                        >
                            {term}
                        </button>
                    ))}
            </div>
        </div>
    )
}

export default PopularSearch
